<template>
  <div>
    <myHeader />
    <banner title="单位详情" />
    <div class="detail-container" v-html="content" />
    <myFooter bgc="black" />
  </div>
</template>

<script>
import { detailLeague, detailSource } from "@/api/common";
import Cookies from "js-cookie";

export default {
  name: "IndexDetail",
  data() {
    return {
      content: ""
    }
  },
  created() {
    let param = this.$route.params
    this.init(param);
  },
  methods: {
    init(param) {
      let detailId = param.id || Cookies.get('dwid')
      let detailType = param.type || Cookies.get('dwtype')
      if (detailType === 'xydw') {
        // 信源单位 401 根据参数查询详情
        detailSource(detailId).then(res => {
          this.content = res.data.content
          Cookies.set("dwid", detailId);
          Cookies.set("dwtype", detailType);
        })
      } else {
        // 联盟单位 401 根据参数查询详情
        detailLeague(detailId).then(res => {
          this.content = res.data.content
          Cookies.set("dwid", detailId);
          Cookies.set("dwtype", detailType);
        })
      }
    },
  }

}
</script>

<style scoped>
.detail-container {
  width: 1140px;
  min-height: 336px;
  margin: 0 auto;
  padding: 20px 0;
}


.submit-main {
  width: 100%;
  min-height: 341px;
}

.submit-main-1 {
  margin: 45px 0 10px 153px;
  font-size: 16px;
  font-weight: 400;
}

.submit-main-2 {
  font-size: 14px;
  font-weight: 400;
  margin-left: 153px;
}

.submit-main-3 {
  margin-left: 153px;
  margin-top: 23px;
  width: 112px;
  height: 32px;
  border-radius: 4px;
  cursor: pointer;

  border: 1px solid rgba(220, 220, 220, 1);

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 16px 5px 16px;
}

.icon {
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/indexdetail.vue